import { useTranslations } from "contexts/LocalizationContext/hooks";
import { usePricingPlanDetailsConfig } from "./config";

const VIEW_ITEM_EVENT_NAME = "view_item_list";
const SELECT_ITEM_EVENT_NAME = "select_item";
const ITEM_LIST_NAME = "Plan offer page bottom";
const ITEM_LIST_ID = "plan_offer_page_bottom";
const ITEM_BRAND = "AirHelp";
const ITEM_CATEGORY = "1YearMembership";
const ITEM_CATEGORY_2 = "Subscription";
const ITEM_SUB_LIST_ID = "plan_offer_page_bottom";
const ITEM_SUB_LIST_NAME = "Plan offer";

const useEssentialPlanTrackingItem = () => {
  const translations = useTranslations();
  const plansConfig = usePricingPlanDetailsConfig();

  const { essential: essentialPlan } = plansConfig;

  return {
    item_id: essentialPlan.planType,
    item_name: translations(essentialPlan.nameText),
    index: 1,
    item_brand: ITEM_BRAND,
    item_category: ITEM_CATEGORY,
    item_category2: ITEM_CATEGORY_2,
    item_list_id: ITEM_SUB_LIST_ID,
    item_list_name: ITEM_SUB_LIST_NAME,
    item_variant: translations(essentialPlan.nameText),
    price: essentialPlan.price,
    quantity: 1,
  }
}

const useCompletePlanTrackingItem = () => {
  const translations = useTranslations();
  const plansConfig = usePricingPlanDetailsConfig();

  const { complete: completePlan } = plansConfig;

  return {
    item_id: completePlan.planType,
    item_name: translations(completePlan.nameText),
    index: 2,
    item_brand: ITEM_BRAND,
    item_category: ITEM_CATEGORY,
    item_category2: ITEM_CATEGORY_2,
    item_list_id: ITEM_SUB_LIST_ID,
    item_list_name: ITEM_SUB_LIST_NAME,
    item_variant: translations(completePlan.nameText),
    price: completePlan.price,
    quantity: 1
  }
}

export const useGetViewItemTrackingEvent = () => ({
  event: VIEW_ITEM_EVENT_NAME,
  item_list_name: ITEM_LIST_NAME,
  item_list_id: ITEM_LIST_ID,
  items: [useEssentialPlanTrackingItem(), useCompletePlanTrackingItem()]
}) as const;

export const useGetSelectItemTrackingEvent = (planName: string) => {
  const essentialPlanItem = useEssentialPlanTrackingItem();
  const completePlanItem = useCompletePlanTrackingItem();

  return ({
    event: SELECT_ITEM_EVENT_NAME,
    item_list_name: ITEM_LIST_NAME,
    item_list_id: ITEM_LIST_ID,
    items: [planName === "essential" ? essentialPlanItem : completePlanItem]
  }) as const;
};
